var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"constrain"},[(_vm.errorMessage)?_c('div',[_vm._v(_vm._s(this.errorMessage))]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }